import { render, staticRenderFns } from "./disciplinePunish.vue?vue&type=template&id=b21e0554&scoped=true&"
import script from "./disciplinePunish.vue?vue&type=script&lang=js&"
export * from "./disciplinePunish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21e0554",
  null
  
)

export default component.exports